<div class="col mt-5 px-lg-5 px-2">
	<!-- <app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportBeneficiaires()"
	></app-nav-gestion-donnees> -->

	<div class="row mb-5 d-flex justify-content-start">
		<button
			*ngIf="isAddable"
			class="col-lg-2 col-5 my-2 mx-2 btn theme-green-button"
			(click)="openModalAjout()"
		>
			<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
		</button>
	</div>

	<input hidden type="file" #uploader (change)="importBeneficiaires($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="onPageChange($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
				>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="onItemsPerPageChange()"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option [value]="10">10</option>
						<option [value]="25">25</option>
						<option [value]="50">50</option>
						<option [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-2 ms-lg-auto">
				<div class="dropdown">
					<a
						class="btn btn-secondary dropdown-toggle"
						profile="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtrer
					</a>
					<div
						class="dropdown-menu px-3 py-3"
						aria-labelledby="dropdownFilter"
						id="menuFilter"
					>
					<div class="row">
						<span class="theme-main-color form-label">Type de handicap</span>
						<div class="row vw-30 ms-0">
							<div
								class="col-4 form-check"
								*ngFor="let expertise of listExpertise"
							>
								<input
									type="checkbox"
									name="{{ expertise.id }}"
									class="form-check-input"
									[value]="expertise"
									(change)="updateSelectedExpertise($event, expertise)"
								/>
								<label class="form-check-label text-dark">
									{{ expertise.name }}
								</label><br/>
							</div>
						</div>
					</div>

					</div>
				</div>
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s), email"
						[(ngModel)]="searchedInput"
						(ngModelChange)="onInputChange()"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')"
					>Nom
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-3">
				<span class="ps-1 hand-cursor fw-bold limitLineSpan">
					Email
				</span>
			</div>
			<div class="col-3">
				<span
					class="ps-1 hand-cursor fw-bold limitLineSpan"
					(click)="sortChange('address.label')"
					>Adresse
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-3" *ngIf="true">
				<span class="hand-cursor fw-bold limitLineSpan"
					>Type de handicap
				</span>
			</div>
			<div class="col-1"></div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let beneficiaire of beneficiaires
						| filterBeneficiaireByName: searchedInput : isIntervenant
						| orderBy : sortType : sortOrder
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Nom :</span>
					{{ beneficiaire?.lastName + ' ' + beneficiaire?.firstName }}
				</span>
				<div class="col-lg-3">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold">Email :</span>
							{{ beneficiaire?.email }}
						</span>
					</div>
				</div>
				<div class="col-lg-3">
					<div class="d-flex">
						<span class="flex-grow-1 limitLineSpan">
							<span *ngIf="isMobile" class="fw-bold">Adresse :</span>
							{{ beneficiaire?.address?.label }}
						</span>
					</div>
				</div>
				<div class="col-12 col-lg-3 d-flex p-lg-0">
					<div class="flex-grow-1">
						<span *ngIf="isMobile" class="fw-bold limitLineSpan"> Type(s) de handicap : </span>
						<span
							*ngFor="let exp of beneficiaire.typeHandicaps; let ilast = last"
							class="me-1 limitLineSpan"
						>
							{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
						</span>

					</div>
				</div>
				<div class="col-12 col-lg-1 d-flex p-lg-0">
					<i
						[routerLink]="['/beneficiaires', beneficiaire.id]"
						profile="button"
						class="fs-4 bi bi-caret-right-fill mb-1 me-2"
						aria-hidden="true"
					></i>
				</div>
			
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="onPageChange($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
				>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="onItemsPerPageChange()"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="5">5</option>
						<option [value]="10">10</option>
						<option [value]="25">25</option>
						<option [value]="50">50</option>
						<option [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
